import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const LoginPage = loadable(() => import(/* webpackChunkName: "LoginPage" */ './LoginPage'), {
  fallback: <LoadableFallback visible />,
});

const asyncLoginPage = ({ route }) => (
  <LoginPage route={route} />
);

asyncLoginPage.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncLoginPage;
